module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/leaf.svg?d1528e9c8d5d3f0c4094e9d0353d56fe";